module.exports = __webpack_public_path__ + "assets/img/Lottery_tit.57809dc2.png";